import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connectLeftSideMenuDesktop } from "./LeftSideMenuDesktop.connect";
import SVG_GreyhoundIcon from "../../assets/images/svgs/greyhound.svg";
import SVG_HorseIcon from "../../assets/images/svgs/horse.svg?react";
import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
import Svg_SpadeIcon from "../../assets/images/svgs/spade-dark.svg?react";
import SVG_SpadeIcon from "../../assets/images/svgs/spade.svg?react";
import SVG_CardDeckIcon from "../../assets/images/svgs/cards-deck.svg?react";
import SVG_RocketIcon from "../../assets/images/svgs/rocket.svg?react";
import SVG_DiceIcon from "../../assets/images/svgs/dice.svg?react";
import SVG_StarIcon from "../../assets/images/svgs/star.svg?react";
import SVG_HomeIcon from "../../assets/images/svgs/home.svg?react";
import SVG_CricketWhiteIcon from "../../assets/images/svgs/cricket_white.svg?react";
import SVG_TennisWhiteIcon from "../../assets/images/svgs/tennis_white.svg?react";
import SVG_PreviousIcon from "../../assets/images/svgs/previous.svg?react";
import SVG_RightIcon from "../../assets/images/svgs/right.svg?react";
import SVG_ElectionIcon from "../../assets/images/svgs/election.svg?react";
import SVG_SportsBook from "../../assets/images/svgs/sportsBook.svg?react";
import { useSelector } from "react-redux";
import { getZonedTime, tsToDate } from "../../helpers/date.helper";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";

const LeftSideMenuDesktop = ({
  menu,
  homeMarketEvents,
  actions,
  timeSettings,
  auth,
  user,
  sportPageEvent,
  sportItemData,
  openSport,
  moreDetailed,
  eventDetailed,
  detailedGroupName,
  competition,
  navigationName,
  sportData,
  hrEventId,
  hrMarketId,
}) => {
  const onOpenDetailedMenu = () => {
    setDetailedSideBar(!detailedSideBar);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const [detailedSideBar, setDetailedSideBar] = useState(false);
  const [oneDetailItem, setOneDetailItem] = useState();
  const [oneDetailName, setOneDetailName] = useState();
  const [displayNone, setDisplayNone] = useState(false);
  const isNavigationOpen = useSelector(
    (state) => state.navigationHeaderMenu.isOpen,
  );
  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }

  useEffect(() => {
    if (isNavigationOpen) {
      setDetailedSideBar(true);
    }
  }, [isNavigationOpen]);

  useEffect(() => {
    if (
      sportData?.length &&
      sportData?.length > 0 &&
      !location.pathname.includes("event-page") &&
      (navigationName === "Greyhound Racing" ||
        navigationName === "Horse Racing")
    ) {
      const alreadyExists = sportData.find(
        (item) =>
          item?.match_id === hrEventId && item?.market_id === hrMarketId,
      );

      if (!alreadyExists) {
        actions.setHrEventId(sportData[0]?.match_id);
        actions.setHrMarketId(sportData[0]?.market_id);
        actions.setHrCountryCode(sportData[0]?.country_code);
      } else {
        actions.setHrCountryCode(alreadyExists?.country_code);
      }
    }
  }, [sportData, location, navigationName, hrEventId, hrMarketId]);

  const GetHomeMarketSuccess = async (...args) => {
    try {
      const result = args[0].map((innerArray) => {
        return innerArray.reduce((acc, item) => {
          const { competitionName } = item;
          const existingIndex = acc.findIndex(
            (obj) => obj.competitionName === competitionName,
          );

          if (existingIndex === -1) {
            acc.push({
              competitionName,
              data: [item],
            });
          } else {
            acc[existingIndex].data.push(item);
          }

          return acc;
        }, []);
      });

      actions.getFreeHomeAllMarketsSuccess(result);
    } catch (error) {
      actions.getFreeHomeAllMarketsError();
    }
  };

  const onMoreDetails = () => {
    actions.setIsEventDetailed(!eventDetailed);
  };

  const FetchHomeAllEvents = async (eventTypeId, competitionId) => {
    const data = {
      eventTypeId,
      competitionId,
    };

    setTimeout(() => {
      actions.requestHomeAllEvents(data);
    }, 500);
  };

  function toTitleCase(str) {
    return str?.replace(
      /\w\S*/g,
      (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
    );
  }

  useEffect(() => {
    if (location.pathname.includes("sports-page")) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[3]);
      setOneDetailName(toTitleCase(segmant[2]));
    } else if (location.pathname.includes("competition-detail-page")) {
      const segmant = location.pathname.split("/");
      actions.setIsEventDetailed(true);
      if (!oneDetailName) {
        setOneDetailItem(segmant[3]);
        setOneDetailName(
          segmant[3] == "1"
            ? "Football"
            : segmant[3] == "2"
              ? "Tennis"
              : segmant[3] == "4"
                ? "Cricket"
                : "",
        );
      }
      actions.setIsDetailedGroupName(decodeURIComponent(segmant[2]));
      FetchHomeAllEvents(segmant[3], segmant[4]);
    } else if (location.pathname.includes("event-page")) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[2]);
      setOneDetailName(
        segmant[2] == "1"
          ? "Football"
          : segmant[2] == "2"
            ? "Tennis"
            : segmant[2] == "4"
              ? "Cricket"
              : "",
      );
      actions.setIsNavigationName(
        segmant[2] == "1"
          ? "Football"
          : segmant[2] == "2"
            ? "Tennis"
            : segmant[2] == "4"
              ? "Cricket"
              : "",
      );
    } else if (
      location.pathname.includes("horse-racing") ||
      location.pathname.includes("greyhound-racing")
    ) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[1]);
      setOneDetailName(
        segmant[1] == "horse-racing"
          ? "Horse Racing"
          : segmant[1] == "greyhound-racing"
            ? "Greyhound Racing"
            : "",
      );
      actions.setIsNavigationName(
        segmant[1] == "horse-racing"
          ? "Horse Racing"
          : segmant[1] == "greyhound-racing"
            ? "Greyhound Racing"
            : "",
      );
    } else {
      setOneDetailName(navigationName);
    }
  }, [location.pathname, navigationName]);

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  const getTimeDifference = (dateTime) => {
    const targetDate = new Date(dateTime);
    const currentDate = new Date();

    const diffInMs = targetDate.getTime() - currentDate.getTime();
    const isPast = diffInMs < 0;
    const diffInSeconds = Math.abs(diffInMs) / 1000;

    const days = Math.floor(diffInSeconds / (3600 * 24));
    const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);

    if (isPast) {
      if (days > 0) return `Started on ${days} days ${hours} hours`;
      return `Started on ${hours} hours ${minutes} minutes`;
    } else {
      if (days > 0) return `Opens in ${days} days ${hours} hours`;
      return `Opens in ${hours} hours ${minutes} minutes`;
    }
  };

  const sideMainMenu =
    !location.pathname.includes("competition-detail-page") &&
    !location.pathname.includes("event-page") &&
    !location.pathname.includes("sports-page") &&
    !location.pathname.includes("horse-racing") &&
    !location.pathname.includes("greyhound-racing");

  return (
    <>
      <div
        title="Menu"
        id="leftDeskSideBar"
        className="hidden lg:flex p-2 overflow-y-auto z-10 w-[20%] h-[calc(100dvh-120px)] sticky top-[54px] lg:top-[110px]"
      >
        {sideMainMenu ? (
          <ul className="flex border rounded-lg border-ternary3 bg-bg_Quaternary-side overflow-x-hidden flex-col w-full ">
            {isSportAvailable("4") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/sports-page/Cricket/4"}
                  onClick={() => {
                    // setOneDetailItem('4')
                    // setOneDetailName('Cricket')
                    actions.setIsNavigationID("4");
                    actions.setIsNavigationName("Cricket");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  <svg
                    width={16}
                    height={16}
                    viewBox="0 0 19 18"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="var(--cricket-icon-color)"
                  >
                    <path
                      d="M4.36255 16.7108C4.35063 16.7037 4.34109 16.6966 4.32917 16.6895C3.88333 16.4077 3.4518 16.107 3.05842 15.7566C2.91299 15.6263 2.77709 15.489 2.63404 15.3564C2.59828 15.3256 2.61974 15.3067 2.63642 15.283C2.81524 15.0533 2.99643 14.8213 3.17524 14.5916C3.92148 13.635 4.6701 12.676 5.41634 11.7194C6.27225 10.6231 7.12578 9.52678 7.98169 8.43047C8.8066 7.37204 9.6339 6.31125 10.4588 5.25282C11.329 4.14231 12.1969 3.02942 13.0647 1.9189C13.2292 1.70816 13.3961 1.49506 13.5582 1.28195C13.5797 1.25354 13.5916 1.24644 13.6274 1.26538C13.9468 1.45244 14.2472 1.67028 14.5333 1.90233C14.6692 2.01125 14.8123 2.1107 14.9458 2.22199C15.0817 2.34038 15.2128 2.46351 15.3439 2.58663C15.3773 2.61742 15.3535 2.63162 15.3368 2.65293C15.1008 2.95602 14.8623 3.26147 14.6263 3.56455C13.9254 4.46433 13.222 5.36411 12.5211 6.26389C11.7343 7.27259 10.9476 8.28129 10.1584 9.29C9.42648 10.2277 8.69693 11.1653 7.965 12.103C7.12101 13.1827 6.2794 14.2648 5.43542 15.3446C5.08971 15.7874 4.7464 16.2278 4.40069 16.6706C4.39116 16.6848 4.38401 16.7037 4.36255 16.7108Z"
                      fill="var(--cricket-icon-color)"
                    />
                    <path
                      d="M17.9928 8.49706C17.9761 8.16556 17.9451 7.83643 17.8927 7.50967C17.8283 7.11424 17.7305 6.72591 17.6137 6.33995C17.3777 5.55146 17.0225 4.8198 16.5814 4.12365C16.4336 3.89161 16.2762 3.66903 16.1022 3.45119C16.0879 3.46776 16.0736 3.48197 16.0617 3.49854C15.7231 3.93423 15.3869 4.36991 15.0484 4.80322C14.2426 5.84271 13.4367 6.88219 12.6309 7.92167C11.7988 8.99431 10.9691 10.0669 10.1371 11.1372C9.34792 12.1554 8.55639 13.1759 7.76724 14.1941C6.99001 15.1981 6.2104 16.202 5.43317 17.2036C5.40456 17.2391 5.40695 17.251 5.44986 17.2699C6.43213 17.6867 7.45492 17.9211 8.52063 17.9803C9.05468 18.0087 9.58872 17.9921 10.1204 17.9258C10.571 17.869 11.0144 17.7814 11.4483 17.6511C12.247 17.412 13.0052 17.0852 13.7157 16.6495C14.4619 16.1925 15.1247 15.6385 15.7112 14.9897C16.0998 14.5587 16.4455 14.097 16.7411 13.5998C17.1917 12.8421 17.5136 12.0346 17.7353 11.1846C17.8736 10.6518 17.9594 10.1096 17.988 9.56022C18.0095 9.20741 18.0119 8.85224 17.9928 8.49706ZM9.17865 15.8587C8.93547 16.1618 8.70182 16.472 8.46579 16.7821C8.3299 16.9621 8.15586 17.0473 7.92936 16.9952C7.69572 16.9408 7.54552 16.7443 7.5479 16.5051C7.54552 16.382 7.58843 16.2754 7.66472 16.1783C7.90075 15.8776 8.13678 15.5745 8.37281 15.2738C8.52778 15.0797 8.7805 15.0063 8.98792 15.1128C9.31931 15.2809 9.336 15.6598 9.17865 15.8587ZM11.105 13.2612C11.0955 13.3606 11.055 13.4435 10.9954 13.5216C10.7569 13.8271 10.5233 14.1349 10.2873 14.4403C10.1633 14.6014 10.0012 14.6795 9.79853 14.644C9.58157 14.6061 9.44567 14.4688 9.39322 14.2557C9.38369 14.2201 9.38369 14.1823 9.3813 14.1444C9.3813 14.026 9.42183 13.9194 9.49336 13.8271C9.73654 13.5169 9.97972 13.2043 10.2253 12.8941C10.3588 12.726 10.6115 12.6621 10.807 12.7426C10.9977 12.8231 11.1265 13.0457 11.105 13.2612ZM12.8407 11.1443C12.5927 11.4569 12.3519 11.7742 12.0992 12.082C11.98 12.2264 11.8131 12.3069 11.6176 12.2643C11.4078 12.2169 11.2695 12.082 11.2242 11.8689C11.1932 11.7268 11.2266 11.5918 11.3172 11.4734C11.5485 11.1704 11.7845 10.872 12.0134 10.5666C12.2494 10.2493 12.7501 10.28 12.9098 10.666C12.936 10.7276 12.9432 10.7915 12.9432 10.8554C12.9432 10.9644 12.9098 11.0591 12.8407 11.1443ZM14.6645 8.77646C14.419 9.09139 14.1758 9.41105 13.9326 9.72834C13.7991 9.90119 13.5678 9.97459 13.358 9.90829C13.1602 9.84673 13.0195 9.66204 13.0123 9.44656C13.0076 9.31633 13.0576 9.19794 13.1363 9.09849C13.3747 8.79067 13.6203 8.48996 13.8635 8.18687C14.0018 8.01639 14.2235 7.95009 14.4238 8.02112C14.624 8.09216 14.7575 8.27922 14.7599 8.49943C14.7528 8.59414 14.7313 8.69122 14.6645 8.77646ZM16.5099 6.40152C16.2667 6.71644 16.0235 7.03373 15.7827 7.34866C15.6254 7.55466 15.4084 7.62333 15.1795 7.53808C14.9888 7.46705 14.86 7.27288 14.8648 7.03847C14.8624 6.94375 14.9077 6.8372 14.9816 6.74012C15.2153 6.44177 15.4465 6.14342 15.6826 5.84508C15.8638 5.61303 16.1308 5.56804 16.3835 5.72432C16.5933 5.85691 16.6601 6.20736 16.5099 6.40152Z"
                      fill="var(--cricket-icon-color)"
                    />
                    <path
                      d="M12.5188 0.709924C11.5127 0.274241 10.4589 0.0469281 9.36222 0.00667475C8.58975 -0.0217394 7.82444 0.0398245 7.06866 0.205573C6.33911 0.364219 5.63817 0.605739 4.97299 0.94434C3.79522 1.54104 2.7915 2.35084 1.96896 3.38559C1.49213 3.98702 1.09398 4.63344 0.784041 5.33432C0.469333 6.04467 0.245222 6.78581 0.116478 7.55062C0.0592586 7.88212 0.0306488 8.21598 0.0163439 8.54985C0.00203901 8.85057 0.00203901 9.14891 0.0163439 9.44963C0.0282647 9.72904 0.0521062 10.0108 0.0902526 10.2878C0.142704 10.6738 0.233302 11.0527 0.338204 11.4268C0.457412 11.8577 0.602845 12.2816 0.791193 12.6888C0.979541 13.0937 1.19888 13.4821 1.4373 13.8609C1.57796 14.0835 1.72816 14.2966 1.89029 14.5097C5.44744 9.91609 8.99982 5.32248 12.5522 0.733602C12.5451 0.717027 12.5308 0.71466 12.5188 0.709924ZM3.05375 11.1379C2.81057 11.4505 2.56739 11.7654 2.31943 12.0732C2.17162 12.2579 1.91651 12.3171 1.70909 12.2082C1.45637 12.0732 1.3014 11.7441 1.5279 11.4741C1.61134 11.3747 1.68525 11.2681 1.76393 11.1639C1.92366 10.9532 2.07863 10.7377 2.24076 10.5294C2.37427 10.3565 2.55308 10.2831 2.77004 10.3328C2.987 10.3826 3.11097 10.5246 3.15627 10.7401C3.15865 10.7472 3.15865 10.7567 3.16104 10.7638C3.16104 10.7851 3.16104 10.8064 3.16104 10.8277C3.16342 10.9414 3.12528 11.0456 3.05375 11.1379ZM4.8824 8.78427C4.68213 9.03999 4.48186 9.29809 4.28159 9.55382C4.24583 9.60117 4.21006 9.64853 4.17192 9.69352C4.06463 9.82849 3.91681 9.89952 3.6784 9.89715C3.5282 9.89242 3.38753 9.77166 3.29932 9.5917C3.21349 9.42122 3.24687 9.2602 3.36369 9.10866C3.60449 8.79611 3.83814 8.47882 4.07655 8.16389C4.20291 7.99814 4.37457 7.92711 4.57722 7.96263C4.78226 7.99814 4.91816 8.1189 4.97538 8.32254C5.02544 8.49302 4.98968 8.64693 4.8824 8.78427ZM6.69673 6.43063C6.4607 6.73372 6.22467 7.03443 5.98864 7.33515C5.85275 7.508 5.66917 7.55772 5.46413 7.508C5.27101 7.46064 5.14704 7.32804 5.09697 7.13625C5.05882 6.98471 5.09935 6.84264 5.18995 6.72424C5.4379 6.40222 5.69301 6.08729 5.95049 5.77C6.07209 5.62083 6.23659 5.5711 6.42017 5.61136C6.61806 5.65398 6.74203 5.78421 6.79687 5.98074C6.80879 6.02099 6.81117 6.06125 6.80879 6.11571C6.81594 6.227 6.77303 6.33355 6.69673 6.43063ZM8.59452 3.9515C8.52538 4.09831 8.41332 4.21433 8.31796 4.33983C8.15107 4.55767 7.98179 4.77551 7.81013 4.98862C7.68139 5.14963 7.50496 5.21119 7.30708 5.17094C7.09727 5.12832 6.96138 4.99572 6.91369 4.78498C6.90654 4.75183 6.90654 4.71395 6.90177 4.67843C6.90416 4.5553 6.95422 4.45348 7.02575 4.35877C7.25701 4.05332 7.49066 3.75023 7.72669 3.44715C7.88166 3.24825 8.13199 3.17722 8.34657 3.2814C8.6279 3.42347 8.71134 3.70288 8.59452 3.9515ZM10.3683 1.70679C10.1299 2.02408 9.88673 2.33663 9.64355 2.65155C9.5148 2.8173 9.28115 2.8836 9.08089 2.81967C8.88062 2.75574 8.74234 2.57105 8.73518 2.35557C8.7328 2.22534 8.78287 2.10695 8.85678 2.00513C9.09042 1.69495 9.32884 1.38713 9.56725 1.07931C9.665 0.953812 9.79852 0.885144 9.97494 0.878041C10.1704 0.894616 10.3254 0.998801 10.4232 1.17639C10.5281 1.36108 10.4899 1.54577 10.3683 1.70679Z"
                      fill="var(--cricket-icon-color)"
                    />
                  </svg>

                  <span className=" font-medium text-start text-text_Ternary-new ">
                    Cricket
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("1") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/sports-page/football/1"}
                  onClick={() => {
                    // setOneDetailItem('1')
                    // setOneDetailName('Football')
                    actions.setIsNavigationID("1");
                    actions.setIsNavigationName("Football");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  <SVG_FootballIcon
                    fill={"var(--color-text-ternary-new)"}
                    width={20}
                    height={20}
                  />
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Football
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("2378961") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/election"}
                  // onClick={() => {
                  //   actions.setIsNavigationID("2378961");
                  //   actions.setIsNavigationName("Election");
                  //   onOpenDetailedMenu(!detailedSideBar);
                  //   actions.setRenderIonContent(false);
                  //   setDisplayNone(false);
                  //   actions.setIsEventDetailed(false);
                  // }}
                >
                  <SVG_ElectionIcon width={20} height={20} />
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Election
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("2") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/sports-page/tennis/2"}
                  onClick={() => {
                    // setOneDetailItem('2')
                    // setOneDetailName('Tennis')
                    actions.setIsNavigationID("2");
                    actions.setIsNavigationName("Tennis");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  <SVG_TennisIcon width={20} height={20} />
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Tennis
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("7") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/horse-racing"}
                  onClick={() => {
                    const horseRacing = { sport_id: "7" };

                    setOneDetailName("Horse Racing");
                    getMenu(horseRacing);
                    actions.setIsNavigationID("7");
                    actions.setIsNavigationName("Horse Racing");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  <svg
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlSpace="preserve"
                    viewBox="10.35099 0 170.59965 192.83511000000001"
                    y={0}
                    x={0}
                    width={20}
                    height={20}
                    fill="#864D44"
                    className="w-[16px] h-[16px]"
                  >
                    <g transform="translate(-.981 -.981)scale(1.01)">
                      <path
                        opacity={1}
                        // fill="#864D44"
                        fill="var(--horse-icon-color)"
                        d="M37.332 151.44c-25.932 -38.27 -7.631 -68.158 -7.631 -68.158 -4.252 -1.259 -17.851 7.653 -17.851 7.653 7.648 -28.029 49.717 -51.843 49.717 -51.843 -4.67 -1.709 -17.845 1.686 -17.845 1.686 34.417 -33.124 76.49 -20.807 76.49 -20.807C121.482 12.742 142.314 0 142.314 0c-2.131 2.11 -2.99 13.6 -2.99 13.6 2.125 -3.83 8.936 -7.653 8.936 -7.653 -3.821 8.912 0 28.03 0 28.03 11.047 11.057 23.366 49.307 23.366 49.307l4.688 6.797c5.951 8.511 3.764 21.892 -2.131 25.065 -22.09 11.926 -24.227 -9.767 -24.227 -9.767 -18.274 -2.125 -31.874 -22.529 -31.874 -22.529 -24.639 12.745 -10.916 48.7 -0.277 62.507 13.669 17.698 3.66 46.328 3.66 46.328s-58.527 -2.424 -84.133 -40.244"
                      />
                    </g>
                  </svg>
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Horse Racing
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("4339") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={"/greyhound-racing"}
                  onClick={() => {
                    const horseRacing = { sport_id: "4339" };

                    setOneDetailName("Greyhound Racing");
                    getMenu(horseRacing);
                    actions.setIsNavigationID("4339");
                    actions.setIsNavigationName("Greyhound Racing");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  <svg
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlSpace="preserve"
                    viewBox="0.8406520000000001 94.153024 422.847956 233.70125600000003"
                    y={0}
                    x={0}
                    version="1.1"
                    width={16}
                    height={16}
                    fill="var(--color-iconsColor)"
                  >
                    <g>
                      <path
                        opacity={1}
                        fill="var(--color-iconsColor)"
                        d="M228.053 116.191c.479.052-.456-.124 0 0z"
                      />
                      <path
                        opacity={1}
                        fill="var(--color-iconsColor)"
                        d="m415.501 229.82-101.146-52.965c-2.592-11.371-8.942-25.952-24.06-38.143-15.015-12.109-35.906-19.814-62.242-22.521L27.658 94.656a8.995 8.995 0 0 0-9.797 7.198c-.113.571-2.711 14.166 2.438 30.739 2.181 7.02 5.985 15.256 12.577 23.378l-26.269 7.247A8.999 8.999 0 0 0 .21 173.822c.122.556 3.114 13.764 14.148 26.747 7.718 9.082 20.66 19.491 41.182 23.883-18.63 40.612-24.831 77.128-25.109 78.809a9 9 0 0 0 7.96 10.424l116.955 11.99a9.002 9.002 0 0 0 9.635-6.712c6.019-23.404 17.513-54.518 47.719-54.518 15.748 0 33.407 7.798 48.724 15.107 21.949 10.475 42.852 15.786 62.125 15.786 35.848 0 56.374-18.09 63.731-26.137 26.525-1.407 32.873-22.809 33.043-31.227a8.997 8.997 0 0 0-4.822-8.154zm-129.957-36.751a11.508 11.508 0 0 1-8.513 3.724 11.553 11.553 0 0 1-11.575-11.126c-.249-6.385 4.737-11.782 11.115-12.037a11.554 11.554 0 0 1 12.039 11.117 11.517 11.517 0 0 1-3.066 8.322z"
                      />
                    </g>
                  </svg>
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Greyhound Racing
                  </span>
                </Link>
              </li>
            )}
            {(isSportAvailable("-100") || isSportAvailable("GAP")) && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  // to={userData?.is_demo ? "#" : "/livegames/aura/FAWK"}
                  to={"#"}
                  // onClick={() => {
                  //   if (userData?.is_demo) {
                  //     toastr.error("", "Please login from your read ID.");
                  //     return;
                  //   }
                  // }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (auth) {
                      if (userData?.is_demo) {
                        toastr.error("", "Please login from your read ID.");
                        return;
                      }
                      if (isSportAvailable("-100")) {
                        navigate("/livegames/aura/FAWK");
                      } else {
                        navigate("/casino-lobby/gapcasino/AURA");
                      }
                      if (!location.pathname.includes("livegames/aura/FAWK")) {
                        actions.openSlotCasinoPopUp();
                      }
                    } else {
                      actions.setLoginNew(true);
                      actions.setLoginNavigationData({
                        page: "livegames/aura/FAWK",
                        ids: [],
                      });
                    }
                  }}
                >
                  <SVG_SpadeIcon
                    width={15}
                    height={15}
                    fill={"var(--color-secondary)"}
                  />
                  <span className=" font-medium text-start text-text_Ternary-new">
                    Indian Card Games
                  </span>
                </Link>
              </li>
            )}

            <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
              <Link
                className="flex w-full items-center h-full px-6 justify-start gap-3"
                // to={"#"}
                to={"/sports-page/Sportsbook/0"}
                onClick={() => {
                  actions.setIsNavigationID("0");
                  actions.setIsNavigationName("Sportsbook");
                }}
              >
                <SVG_SportsBook />
                <span className=" font-medium text-start text-text_Ternary-new">
                  Sportsbook
                </span>
              </Link>
            </li>
            {(isSportAvailable("QT") || isSportAvailable("GAP")) && (
              <>
                <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3"
                    to={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-lobby/casino");
                        if (
                          !location.pathname.includes("/casino-lobby/casino")
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "casino-lobby/casino",
                          ids: [],
                        });
                      }
                    }}
                  >
                    <SVG_CardDeckIcon />
                    <span className=" font-medium text-start text-text_Ternary-new">
                      Live Casino
                    </span>
                  </Link>
                </li>
                <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3"
                    to={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate(
                          isSportAvailable("QT")
                            ? "/casino-live/SPB-aviator/SPB"
                            : "/gapcasino-live/151027/Virtual/MAC88",
                        );
                        if (
                          !location.pathname.includes(
                            isSportAvailable("QT")
                              ? "/casino-live/SPB-aviator/SPB"
                              : "/gapcasino-live/151027/Virtual/MAC88",
                          )
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: isSportAvailable("QT")
                            ? "/casino-live/SPB-aviator/SPB"
                            : "/gapcasino-live/151027/Virtual/MAC88",
                          ids: [],
                        });
                      }
                    }}
                  >
                    <SVG_RocketIcon />
                    <span className=" font-medium text-start text-text_Ternary-new">
                      Aviator
                    </span>
                  </Link>
                </li>
                <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3"
                    to={userData?.is_demo ? "#" : "/slot-games"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-lobby/slot-games");
                        if (
                          !location.pathname.includes(
                            "/casino-lobby/slot-games",
                          )
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "casino-lobby/slot-games",
                          ids: [],
                        });
                      }
                    }}
                  >
                    <SVG_DiceIcon />
                    <span className=" font-medium text-start text-text_Ternary-new">
                      Slot Games
                    </span>
                  </Link>
                </li>
              </>
            )}

            {/* {isSportAvailable("GAP") && (
              <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3"
                  to={userData?.is_demo ? "#" : "/slot-games"}
                  onClick={(e) => {
                    e.preventDefault();
                    if (auth) {
                      if (userData?.is_demo) {
                        toastr.error("", "Please login from your read ID.");
                        return;
                      }
                      navigate("/casino-lobby/gapcasino");
                      if (
                        !location.pathname.includes("/casino-lobby/gapcasino")
                      ) {
                        actions.openSlotCasinoPopUp();
                      }
                    } else {
                      actions.setLoginNew(true);
                      actions.setLoginNavigationData({
                        page: "casino-lobby/gapcasino",
                        ids: [],
                      });
                    }
                  }}
                >
                  <SVG_DiceIcon />
                  <span className=" font-medium text-start text-text_Ternary-new">
                    MAC88
                  </span>
                </Link>
              </li>
            )} */}
          </ul>
        ) : (
          <>
            {!sideMainMenu && !eventDetailed && !displayNone && (
              <ul className="flex border rounded-lg border-ternary3 bg-bg_Quaternary-side overflow-x-hidden flex-col w-full ">
                <ul className="flex overflow-x-hidden flex-col w-full no-scrollbar ">
                  {/* <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      <SVG_StarIcon />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Favourites
                      </span>
                    </span>
                  </li> */}

                  <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllCompetitionError();
                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_HomeIcon fill="var(--icon-color-brand-secondary)" />
                      <span className=" font-medium text-start text-text_Ternary-new">
                        Sports
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_Secondary  whitespace-nowrap autoAnimate font-semibold w-full border-b border-b-secondary hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      {oneDetailName == "Cricket" ? (
                        <SVG_CricketWhiteIcon />
                      ) : oneDetailName == "Football" ? (
                        <SVG_FootballIcon />
                      ) : oneDetailName === "Tennis" ? (
                        <SVG_TennisWhiteIcon />
                      ) : navigationName === "Horse Racing" ? (
                        <SVG_HorseIcon className="horse-icon" />
                      ) : navigationName === "Greyhound Racing" ? (
                        <img
                          src={SVG_GreyhoundIcon}
                          className="greyHound-icon"
                        />
                      ) : oneDetailName === "Sportsbook" ? (
                        <SVG_SportsBook />
                      ) : null}
                      <span className=" font-medium text-start text-text_Quaternary">
                        {oneDetailName || navigationName}
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_SideBarDeskBg  whitespace-nowrap autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllCompetitionError();
                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_PreviousIcon />
                      <span className=" font-medium text-start text-text_Secondary-new">
                        Previous
                      </span>
                    </span>
                  </li>

                  {sportData?.length &&
                  !location.pathname.includes("event-page") &&
                  (navigationName === "Greyhound Racing" ||
                    navigationName === "Horse Racing")
                    ? sportData?.map((item, index) => {
                        return (
                          <li
                            key={item?.market_id}
                            id={item?.market_id}
                            className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] "
                          >
                            <span
                              className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3"
                              onClick={() => {
                                actions.setHrEventId(item.match_id);
                                actions.setHrMarketId(item?.market_id);
                                actions.setHrCountryCode(item.country_code);

                                // onMoreDetails(!eventDetailed);
                                // setTimeout(() => {
                                //   onOpenDetailedMenu(!detailedSideBar);
                                // }, 1000);
                                // actions.setIsAnimatedMenu(true);
                                // actions.setIsMoreDetailed(true);

                                // navigate(
                                //   `/event-page/${item?.sport_id}/${item?.market_id}/${item.match_id}`
                                // );
                              }}
                            >
                              <span className=" font-medium text-start text-text_Ternary-new text-wrap">
                                {item.venue}
                                &nbsp; ({item.country_code})
                                <br />
                                <span className=" text-x text-text_color_primary3  text-wrap">
                                  {getTimeDifference(
                                    getZonedTime(
                                      timeSettings?.timeZoneName,
                                      item.market_start_time,
                                    ),
                                  )}
                                </span>
                              </span>
                              <span className="opacity-50">
                                <SVG_RightIcon />
                              </span>
                            </span>
                          </li>
                        );
                      })
                    : null}

                  {homeMarketEvents.homeAllCompetition?.length &&
                  navigationName !== "Greyhound Racing" &&
                  navigationName !== "Horse Racing"
                    ? homeMarketEvents.homeAllCompetition?.map(
                        (item, index) => {
                          return (
                            <li
                              key={item?.series_id}
                              id={item?.series_id}
                              className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] "
                            >
                              <span
                                className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3"
                                onClick={() => {
                                  actions.setIsNavigationOpen(false);
                                  actions.setRenderIonContent(false);

                                  onMoreDetails(!eventDetailed);
                                  setTimeout(() => {
                                    onOpenDetailedMenu(!detailedSideBar);
                                  }, 1000);
                                  actions.setIsAnimatedMenu(true);
                                  actions.setIsMoreDetailed(true);
                                  // actions.setIsDetailedGroupName(item.name);

                                  // FetchHomeAllEvents(oneDetailItem, item.id);
                                  navigate(
                                    `/competition-detail-page/${item?.series_name ?? item?.name}/${oneDetailItem}/${item.series_id}`,
                                  );
                                }}
                              >
                                <span className=" font-medium text-start text-text_Ternary-new  text-wrap">
                                  {item?.series_name ?? item?.name}
                                </span>
                                <span className="opacity-50">
                                  <SVG_RightIcon />
                                </span>
                              </span>
                            </li>
                          );
                        },
                      )
                    : null}
                </ul>
              </ul>
            )}

            {eventDetailed && (
              <ul className="flex border rounded-lg border-ternary3 bg-bg_Quaternary-side  overflow-x-hidden flex-col w-full ">
                <ul className="flex overflow-x-hidden flex-col w-full no-scrollbar ">
                  {/* <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      <SVG_StarIcon />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Favourites
                      </span>
                    </span>
                  </li> */}
                  <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center  h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllEventsError();
                        actions.setIsEventDetailed(false);
                        actions.setIsDetailedGroupName("");

                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_HomeIcon fill="var(--icon-color-brand-secondary)" />
                      <span className=" font-medium text-start text-text_Ternary-new">
                        Sports
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_Secondary  whitespace-nowrap autoAnimate font-semibold w-full border-b border-b-secondary hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      {oneDetailName == "Cricket" ? (
                        <SVG_CricketWhiteIcon />
                      ) : oneDetailName == "Football" ? (
                        <SVG_FootballIcon />
                      ) : oneDetailName === "Tennis" ? (
                        <SVG_TennisWhiteIcon />
                      ) : navigationName === "Horse Racing" ? (
                        <SVG_HorseIcon className="horse-icon" />
                      ) : navigationName === "Greyhound Racing" ? (
                        <img
                          src={SVG_GreyhoundIcon}
                          className="greyHound-icon"
                        />
                      ) : null}
                      <span className=" font-medium text-start text-text_Quaternary">
                        {oneDetailName || navigationName}
                      </span>
                    </span>
                  </li>

                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_SideBarDeskBg  whitespace-nowrap autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate(-1);
                        actions.getHomeAllEventsError();
                        actions.setIsEventDetailed(false);
                        actions.setIsDetailedGroupName("");
                      }}
                    >
                      <SVG_PreviousIcon />
                      <span className=" font-medium text-start text-text_Secondary">
                        Previous
                      </span>
                    </span>
                  </li>

                  {competition && competition?.length > 0 ? (
                    <>
                      <li className="text-sm cursor-pointer py-4 text-nowrap  bg-bg_SideBarDeskBg autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                        <span
                          className="flex w-full items-center whitespace-pre-wrap h-full px-6 justify-start gap-3"
                          onClick={() => {
                            navigate(-1);
                            actions.getHomeAllEventsError();
                            actions.setIsEventDetailed(false);
                            actions.setIsDetailedGroupName("");
                          }}
                        >
                          <span className=" font-medium text-start text-text_Secondary">
                            {detailedGroupName}
                          </span>
                        </span>
                      </li>

                      {competition.map((item, index) => {
                        return (
                          <li
                            key={item.match_id}
                            className="text-sm cursor-pointer py-4 text-nowrap whitespace-nowrapautoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%]"
                          >
                            <Link
                              to={`/event-page/${oneDetailItem}/${item.match_id}`}
                            >
                              <span className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3">
                                <span className=" font-medium text-start text-text_Ternary-new  text-wrap">
                                  {item.match_name}
                                </span>
                                <span className="opacity-50">
                                  <SVG_RightIcon />
                                </span>
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                    </>
                  ) : null}
                </ul>
              </ul>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default connectLeftSideMenuDesktop()(LeftSideMenuDesktop);
